import { showErrorAlert } from "../helpers/alert";
import apiClient from "../helpers/apiClient";
import { handleApiError, parseApiErrors } from "../utils/handleApiError";

const Logout = () => {
    window.location.href = '/';
}

export const getListTeam = async (teamId:number,params:any) => {
    try {
        const response = await apiClient.get(`/moderation/teams/${teamId}/members/`, { params: params });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
};

export const getDetailTeam = async (teamId:number,membershipId:number) => {
    try {
        const response = await apiClient.get(`/moderation/teams/${teamId}/members/${membershipId}/`, {});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
};

export async function createTeam(data: any) {
    try {
        const response = await apiClient.post(`/my-team-invite/`, data,{ 
            headers: { 
                Accept: 'application/json',
                "Content-Type": "application/json",
            } 
        });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
    
}

export async function updateTeam(teamId:number,membershipId:number,data: any,formData: boolean=false) {
    try {
        let headers = {};
        if(formData){
            headers = { 
                Accept: 'application/json',
                "Content-Type": "multipart/form-data",
            }
        }else{
            headers = { 
                Accept: 'application/json',
                "Content-Type": "application/json",
            };
        }
        const response = await apiClient.put(`/moderation/teams/${teamId}/members/${membershipId}/`, data,{ headers: headers });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function deleteTeam(teamId:number,membershipId:number) {
    try {
        const response = await apiClient.delete(`/moderation/teams/${teamId}/members/${membershipId}/`, { 
            headers: { 
                Accept: 'application/json',
                "Content-Type": "application/json",
            } 
        });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function createModerationTeam(data:any){
    try {
        const response = await apiClient.post(`/moderation/teams/`,data,{});
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}

export async function moderationTeamCheck(data:any){
    try {
        const response = await apiClient.get(`/moderation/teams/check-user/`, { 
            params: data
        });
        return response.data;
    } catch (error) {
        handleApiError(error, {});
    }
}